export default "__VITE_ASSET__DlZ9l5m1__"